module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('title.controller-details')) + ": " + _vm._s(_vm.controller.name) + " ")]), _vm._v(" "), _c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.controller-details')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('controller-form', {
    attrs: {
      "controller": _vm.controller
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.controller-diagnosis')
    }
  }, [_c('controller-diagnosis', {
    attrs: {
      "controller": _vm.controller
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.switches')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, _vm._l((_vm.switches), function(switchx, i) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('h2', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.$t('switch')))]), _vm._v(" "), _c('switch-form', {
      attrs: {
        "switchx": switchx
      }
    }), _vm._v(" "), _c('server-switch-form', {
      attrs: {
        "switchx": switchx
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.controller-wifi-settings')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('controller-wifi-setting', {
    attrs: {
      "controller": _vm.controller
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.readers')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, _vm._l((_vm.relatedReaders), function(reader) {
    return _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('reader-form', {
      attrs: {
        "reader": reader
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.inputs')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, _vm._l((_vm.relatedInputs), function(input) {
    return _c('el-col', {
      key: input.id,
      attrs: {
        "span": 12
      }
    }, [_c('input-form', {
      attrs: {
        "input": input
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.in-progress-accesses')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('data-table', {
    attrs: {
      "model": _vm.unprocessedAccesses,
      "columns": ['contact_name', 'switch.name', 'attempts', '[T]key_type']
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.tx-power')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('controller-tx-power', {
    attrs: {
      "controller": _vm.controller
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.command')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('command-builder', {
    attrs: {
      "controller": _vm.controller
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7bfdb80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controller/ControllerDetails.vue
// module id = 1033
// module chunks = 2